var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10C17.5523 10 18 10.4477 18 11L18 19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19L16 11C16 10.4477 16.4477 10 17 10Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10C3.55228 10 4 10.4477 4 11L4 19C4 19.5523 3.55228 20 3 20C2.44771 20 2 19.5523 2 19L2 11C2 10.4477 2.44772 10 3 10Z",
    fill: "#003393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7C10.5523 7 11 7.44771 11 8L11 19C11 19.5523 10.5523 20 10 20C9.44771 20 9 19.5523 9 19L9 8C9 7.44771 9.44772 7 10 7Z",
    fill: "#003393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11C2 10.4477 2.44771 10 3 10L17 10C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12L3 12C2.44772 12 2 11.5523 2 11Z",
    fill: "#003393"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    transform: "rotate(90 17 17)",
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 17,
    r: 2,
    transform: "rotate(90 10 17)",
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 17,
    r: 2,
    transform: "rotate(90 3 17)",
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 7.55228 13.5523 8 13 8L7 8C6.44772 8 6 7.55229 6 7C6 6.44772 6.44772 6 7 6L13 6C13.5523 6 14 6.44771 14 7Z",
    fill: "#003393"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.54979e-08C13.5523 1.17194e-07 14 0.447715 14 1L14 7C14 7.55228 13.5523 8 13 8C12.4477 8 12 7.55228 12 7L12 1C12 0.447715 12.4477 3.38016e-08 13 7.54979e-08Z",
    fill: "#003393"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7.54979e-08C7.55229 1.17194e-07 8 0.447715 8 1L8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7L6 1C6 0.447715 6.44772 3.38016e-08 7 7.54979e-08Z",
    fill: "#003393"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.999999C14 1.55228 13.5523 2 13 2L7 2C6.44772 2 6 1.55229 6 1C6 0.447716 6.44772 -7.82811e-08 7 -1.74846e-07L13 -1.22392e-06C13.5523 -1.32048e-06 14 0.447714 14 0.999999Z",
    fill: "#003393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.a972a70e5323aea4830b2dfd5ab4dacc.svg";
export { ForwardRef as ReactComponent };